var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bastion-the-x"},[_c('div',{staticClass:"title-text"},[_c('h1',[_vm._v("\n      Bastion The"),_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.name))])]),_c('div',{style:(_vm.cursorStyle)})])])}
var staticRenderFns = []

export { render, staticRenderFns }